<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
          cols="12"
          sm="8"
          md="7"
          class="text-center">
        <v-card class="elevation-12">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Сброс пароля') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <v-alert
                class="text-center"
                :value="success"
                type="success">
              {{ $t('Пароль успешно изменен и отправлен на электронную почту пользователя.') }}
            </v-alert>
            <general-error v-if="!!generalError" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { ACCOUNT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError
    },
    props: {
      userName: {
        type: String
      },
      code: {
        type: String
      }
    },
    data () {
      return {
        isLoading: false,
        success: false,
        login: null
      }
    },
    computed: {
    },
    created () {
      if (this.isLoggedIn) {
        this.goToRoute(`${this.urlRootPath}/`)
      }
      this.resetPasswordConfirmed()
    },
    methods: {
      ...mapActions(ACCOUNT.NAMESPACE, {
        resetPasswordConfirmedAction: ACCOUNT.ACTIONS.RESET_PASSWORD_CONFIRMED
      }),
      resetPasswordConfirmed: async function () {
        const vm = this
        vm.isLoading = true
        try {
          await vm.resetPasswordConfirmedAction({
            userName: vm.userName,
            code: vm.code.replace(/[;]/g, '/')
          })
          vm.isLoading = false
          vm.success = true
          if (!vm.generalError) {
            setTimeout(function () {
              vm.goToRoute(`${vm.urlRootPath}/login`)
            }, 12000)
          }
        } catch (error) {
          vm.isLoading = false
          vm.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
